module.exports = __webpack_public_path__ + "media/components/country-flag/static/ch-be458803ac691e8632f994c2bd92d13d.svg";